import React, { useEffect, useState } from 'react'
import styles from './style.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGem, faListAlt, faStar } from '@fortawesome/free-solid-svg-icons';
import { postedJobsCount } from '../../action/jobs';

const PostedJobCount = () => {
    const [data, setData] = useState(null);
    useEffect(() => {
        postedJobsCount().then((res) => {
            if (res.status) {
                setData({
                    regularCount: res.result.regular.total,
                    featuredCount: res.result.featured.total,
                    premiumCount: res.result.premium.total,
                    totaljobsbalance: res.result.totaljobsbalance,
                })
            }
        })
    }, [])
    return (
        <React.Fragment>
            <div className='row my-3 '>
                <div className={`${styles['mw-33']} col-md-4`}>
                    <div className={`${styles['custom-card']} text-start`}>
                        <div className='d-flex justify-content-between align-items-center'>
                            <div className={`${styles['re-title']} text-title`}>
                                <h4 className='mb-1'>Regular Jobs</h4>
                                <h5 className='mb-0'>{data?.regularCount} out of {data?.totaljobsbalance?.REGULAR_POSTING}</h5>
                            </div>
                            <div className={`${styles['icon-container']}`}>
                                <FontAwesomeIcon icon={faListAlt} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles['mw-33']} col-md-4`}>
                    <div className={`${styles['feature-card']} text-start`}>
                        <div className='d-flex justify-content-between align-items-center'>
                            <div className={`${styles['re-title']} text-title`}>
                                <h4 className='mb-1'>Feature Jobs</h4>
                                <h5 className='mb-0'>{data?.featuredCount} out of {data?.totaljobsbalance?.FEATURED_POSTING}</h5>
                            </div>
                            <div className={`${styles['icon-container']}`}>
                                <FontAwesomeIcon icon={faStar} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles['mw-33']} col-md-4`}>
                    <div className={`${styles['premium-card']} text-start`}>
                        <div className='d-flex justify-content-between align-items-center'>
                            <div className={`${styles['re-title']} text-title`}>
                                <h4 className='mb-1'>Premium Jobs</h4>
                                <h5 className='mb-0'>{data?.premiumCount} out of {data?.totaljobsbalance?.PREMIUM_POSTING}</h5>
                            </div>
                            <div className={`${styles['icon-container']}`}>
                                <FontAwesomeIcon icon={faGem} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default PostedJobCount